import React from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function TraegerPageSelector({ form, onChange }) {
  const total = form.page_count || 0;
  if (total < 2) return null;
  const excl = form.excluded_pages || [];
  const toggle = async (p) => {
    const next = excl.includes(p) ? excl.filter((x) => x !== p) : [...excl, p];
    try {
      const { data } = await api.put(`/traeger-forms/form/${form.form_id}/pages`, { excluded_pages: next });
      onChange(data.excluded_pages);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };
  return (
    <div className="border border-slate-200 bg-white px-4 py-3" data-testid="traeger-page-selector">
      <div className="text-[10px] font-bold uppercase tracking-overline text-slate-500 mb-2">
        Seiten im PDF · {total - excl.length} von {total}
      </div>
      <div className="flex flex-wrap gap-2">
        {Array.from({ length: total }, (_, i) => i + 1).map((p) => {
          const on = !excl.includes(p);
          const filled = (form.form_pages || []).includes(p);
          const auto = (form.auto_excluded_pages || []).includes(p);
          return (
            <label key={p} className={`inline-flex items-center gap-1.5 border px-2.5 py-1 text-xs cursor-pointer transition-colors ${on ? "border-[#0a788c] bg-[#0a788c]/5 text-slate-900" : "border-slate-200 text-slate-400 line-through"}`}
              data-testid={`traeger-page-${p}`}>
              <input type="checkbox" checked={on} onChange={() => toggle(p)} className="accent-[#0a788c] w-3 h-3" data-testid={`traeger-page-checkbox-${p}`} />
              Seite {p}{filled ? " · ausgefüllt" : ""}{auto ? " · Anschreiben" : ""}
            </label>
          );
        })}
      </div>
      <div className="text-[11px] text-slate-500 mt-2">Seiten ohne Häkchen fehlen beim Drucken, Herunterladen und Senden (z. B. ein Anschreiben, das das Jobcenter nicht braucht). Standardmäßig bleiben alle Seiten im PDF; erkannte Anschreiben sind markiert und können bei Bedarf abgewählt werden.</div>
    </div>
  );
}
